import React, { useState } from "react";
import {
  /*Mlk,*/
  ForeignGeneer,
  Vapeur,
  Eventi,
  /*TheDroneGarden,*/
} from "../components";

import img_ForeignGeneer from '../assets/images/ForeignGeneer/ForeignGeneer_spawn.png';
import img_Eventi from '../assets/images/Symfony/Eventi_home.png';
import img_Vapeur from '../assets/images/Vapeur/Vapeur_title.png';
/*import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';*/
import '../assets/styles/Project.scss';

type ProjectList = {
  id: number;
  title: string;
  image: string;
  link: string;
  description: string;
  contenu: any;
  category:string; // Ajout de la propriété category
};

// Définition des catégories disponibles
const categories = ["Tous", "Web", "Jeux vidéo", "3D"];

function Project() {
    const [selectedProject, setSelectedProject] = useState<ProjectList | null>(null);
    const [activeFilter, setActiveFilter] = useState<string>("Tous");

    const projects: ProjectList[] = [
       {
            id: 1,
            title: "Vapeur",
            image: img_Vapeur,
            link: "https://github.com/Nagiraud/Vapeur",
            description: "Developed movie finder app with semantic search and sentiment analysis using OpenAI GPT-3.5 Turbo, Qdrant, React, and Flask.",
            contenu:<Vapeur />,
            category: "Web"
        },
        
        {
            id: 2,
            title: "ForeignGeneer",
            image: img_ForeignGeneer,
            link: "https://github.com/Nagiraud/ForeignGeneer",
            description: "Jeux vidéo d'exploration en monde ouvert, développé sur le moteur de jeu Godot.",
            contenu:<ForeignGeneer />,
            category: "Jeux vidéo"
        },
        {
            id: 3,
            title: "Eventi",
            image: img_Eventi,
            link: "https://github.com/Nagiraud/API-Symfony",
            description: "Eventi est un site web développé sur Symfony. Il permet de gérer une collection d'événements et d'artistes, soumis par les utilisateurs eux-mêmes.",
            contenu:<Eventi />,
            category: "Web"
        },
        /*{
            id: 4,
            title: "The Drone Garden",
            image: img_Eventi,
            link: "https://github.com/Nagiraud/The-Drone-Garden",
            description: "Jeux de gestion de potager",
            contenu:<TheDroneGarden />,
            category: "Jeux vidéo"
        },*/
        /*{
            id: 4,
            title: "Martin Museum",
            image: mock09,
            link: "",
            description: "Designed, developed, and launched a 3D multiplayer racing game with C# and Unity. This is available on Itch.io for gamers worldwide to enjoy.",
            contenu:<Mlk />,
            category: "Web"
        },
        {
            id: 5,
            title: "3D",
            image: mock08,
            link: "https://www.artstation.com/nataxe05076",
            description: "This is an online educational platform that provides high-quality, data science-focused learning resources in the Japanese language. I created the entire platform from scratch using Ruby on Rails.",
            contenu:"",
            category: "3D"
        },*/

    ];

    // Filtrer les projets selon la catégorie active
    const filteredProjects = activeFilter === "Tous" 
        ? projects 
        : projects.filter(project => project.category === activeFilter);

    return (
        <div className="projects-container" id="projects">
            
            <h1>Projets personnels</h1>
            
            {/* Système de filtres amélioré */}
            <div className="filters">
                {categories.map((category) => (
                    <button 
                        key={category}
                        className={activeFilter === category ? 'active' : ''}
                        onClick={() => setActiveFilter(category)}
                    >
                        {category}
                        {/* Afficher le nombre de projets pour chaque catégorie */}
                        <span className="count">
                            ({category === "Tous" 
                                ? projects.length 
                                : projects.filter(p => p.category === category).length
                            })
                        </span>
                    </button>
                ))}
            </div>

            <div className="projects-grid">
                {filteredProjects.map((project) => (
                    <div className="project" key={project.id} onClick={() => setSelectedProject(project)}>
                        <img src={project.image} className="zoom" alt="thumbnail" width="100%"/>
                        <div className="project-info">
                            <span className="project-category">{project.category}</span>
                            <h2>{project.title}</h2>
                            <p>{project.description.substring(0, 200)}</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* Message si aucun projet dans la catégorie */}
            {filteredProjects.length === 0 && (
                <div className="no-projects">
                    <p>De nouveaux projets apparaîtront bientôt dans cette catégorie !</p>
                </div>
            )}

            {selectedProject && (
                <div className="modal-overlay" onClick={() => setSelectedProject(null)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal" onClick={() => setSelectedProject(null)}>
                           <p>&times;</p>
                        </button>
                        <img src={selectedProject.image} alt={selectedProject.title} className="modal-image"/>
                        <div className="modal-info">
                            
                            <p>{selectedProject.contenu}</p>
                            <a 
                                href={selectedProject.link} 
                                target="_blank" 
                                rel="noreferrer" 
                                className="project-link"
                            >
                                Voir le projet
                            </a>
                        </div>
                    </div>
                </div>
            )}
            <div className="avenir">
                <p>De nouveaux projets sont à venir !</p>
            </div>
        </div>
    );
}

export default Project;